module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('h2', {
    staticClass: "nobreak"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre13",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre14"
  }, [_c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "allsmcap"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "allsmcap"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Coming of Betsy")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("      1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The New Surroundings")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_10"
    }
  }, [_vm._v("      10")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Coming of the Prince")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_22"
    }
  }, [_vm._v("      22")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Betsy Meets Van")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#Page_36"
    }
  }, [_vm._v("      36")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van’s First Lessons")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#Page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      47")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Betsy’s First Lessons")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      62")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van Goes to Church")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      74")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Great Storm")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      87")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("More Lessons")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      100")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van’s Wild Oats")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      113")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van Becomes a Hero")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      128")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Great Parade")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      143")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van in Disgrace")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      156")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van’s Banishment")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      171")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van’s Hard Lessons")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      183")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Journey Home")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      193")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Van the Rescuer")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      210")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0